export const GCAL = {
  UserPoolId: `${import.meta.env['NX_COGNITO_USER_POOL_ID']}`,
  ClientId: `${import.meta.env['NX_COGNITO_CLIENT_ID']}`,
  Endpoint: `${import.meta.env['NX_COGNITO_ENDPOINT']}`,
};
export const PAGE_SIZE = import.meta.env['NX_PAGE_SIZE'] as string;
export const ASSETS_API = import.meta.env['NX_ASSETS_API'] as string;
export const ASSETS_CDN_URL = import.meta.env['NX_ASSETS_CDN_URL'] as string;
export const COUNTLY_APP_KEY = import.meta.env[
  'NX_EASYCLASS_COUNTLY_APP_KEY'
] as string;
export const COUNTLY_URL = import.meta.env['NX_EASYCLASS_COUNTLY_URL'] as string;

export const CLOUDFLARE_IMAGE_PREFIX = import.meta.env[
  'NX_CLOUDFLARE_IMAGE_PREFIX'
] as string;

export const NX_OPENPANEL_CLIENT_ID = import.meta.env[
  'NX_OPENPANEL_CLIENT_ID'
] as string;

export const NX_OPENPANEL_API_URL = import.meta.env[
  'NX_OPENPANEL_API_URL'
] as string;

export const NX_GRAPHQL_WS_URL = import.meta.env['NX_GRAPHQL_WS_URL'] as string;

export const NX_BUNNY_LIBRARY_ID = import.meta.env['NX_BUNNY_LIBRARY_ID'] as string;
export const NX_LRS_ENDPOINT = import.meta.env['NX_LRS_ENDPOINT'] as string;
export const NX_LRS_KEY = import.meta.env['NX_LRS_KEY'] as string;
export const NX_LRS_SECRET = import.meta.env['NX_LRS_SECRET'] as string;
export const NX_DO_STORAGE = import.meta.env['NX_DO_STORAGE'] as string;
